/* global $:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.promocodes', [
    ])
    .controller('PromoCodesAdminCtrl', PromoCodesAdminCtrl);

  /** @ngInject */
  function PromoCodesAdminCtrl($scope, $state, $stateParams, UsersService) {
    var vm = this;
    vm.userId = $stateParams.parentId;
    vm.items = [];
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    load(1);

    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }

      UsersService.listPromoCodes(vm.userId, vm.oldPage, 25).then(function(result){
        var items = result.results;
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        vm.items = items;
      });
    }

    vm.pageChanged = function(newPage) {
      load(newPage);
    };
  }

})();
